module.exports = __webpack_public_path__ + "img/img-badge-001-off@3x.8d71fbda.png";